export enum SignupResultType {
  OK,
  DUPLICATE,
  ERROR,
}
